import React, { useState } from "react";
import { toastr } from "react-redux-toastr";
import { Controller, useForm } from "react-hook-form";
import { useLead, LeadQualityChange, LeadQuality } from "../../../../core";
import api from "../../../../api";
import { useLeadActivities } from "../../../../core/hooks/useLeadActivities";

export interface FormProps {
  reason: string;
  nextContactDate?: Date;
  comment?: string;
  contactAfter?: string;
}

const RevokeLost: React.FunctionComponent<{
  leadId: string;
}> = (props) => {
  const [isModelOpen, setIsModelOpen] = useState<boolean>(false);
  const { updating, updateLeadQuality } = useLead(api.lead);
  const { getAllLeadActivities: getLeadActivities } = useLeadActivities(
    api.lead
  );

  const { control, handleSubmit } = useForm<FormProps>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });

  const renderModel = () => {
    return isModelOpen ? (
      <>
        <div
          className="modal fade show in"
          id="exampleModal"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-confirm modal-dialog-centered">
            <div className="modal-content rounded-0">
              <div className="modal-body text-center">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="container">
                    <div className="row">
                      <div className="col font-weight-semibold pb-2">
                        <p>Are you sure want to revoke this Opportunity</p>
                      </div>
                    </div>

                    <div className="row gutter-5 justify-content-center">
                      <div className="col-auto">
                        <button
                          type="button"
                          className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4"
                          onClick={() => setIsModelOpen(false)}
                        >
                          Cancel
                        </button>
                      </div>
                      <div className="col-auto">
                        <button
                          type="submit"
                          className="btn btn-primary py-2 font-weight-semibold font-normal px-4"
                          disabled={updating}
                        >
                          Confirm
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show"></div>
      </>
    ) : (
      <></>
    );
  };
  const onSubmit = async (data: FormProps) => {
    const updateData: LeadQualityChange = {
      quality: LeadQuality.Interested,
    };
    updateLeadQuality(
      updateData,
      props.leadId,
      () => {
        toastr.success("Success", "Lead revoked successfully");
        setIsModelOpen(false);
        if (props.leadId) {
          getLeadActivities(props.leadId);
        }
      },
      (err) => {
        toastr.error(
          "Error",
          (err as any).response?.data?.data?.message || "Unable to revoke lead"
        );
      }
    );
  };

  return (
    <>
      <button
        onClick={() => setIsModelOpen(true)}
        className="btn btn-outline-primary px-lg-4 px-2 mb-sm-0 mb-1 font-weight-semibold"
      >
        Revoke
      </button>
      {renderModel()}
    </>
  );
};

export default RevokeLost;
